import firebase from "firebase/app";

export const serviceTopicCollectionKey = "serviceTopics";
export const schoolAIServiceTopicCollectionKey = "serviceTopicsForSchoolAI";

export type ServiceTopic = {
  ref: firebase.firestore.DocumentReference;
  data: ServiceTopicData;
};

export type ServiceTopicData = {
  url: string;
  label: string;
  timestamp: number;
  deliverToChildSchools?: boolean;
};

export function convertToServiceTopic(
  data: firebase.firestore.DocumentData,
  ref: firebase.firestore.DocumentReference
): ServiceTopic {
  const returnData: ServiceTopicData = {
    url: data.url,
    label: data.label,
    timestamp: data.timestamp
  };
  if (typeof data.deliverToChildSchools === "boolean") {
    returnData.deliverToChildSchools = data.deliverToChildSchools;
  }
  return {
    ref,
    data: returnData
  };
}
